import React from "react";
import SessionRoutes from "./Views/Session/SessionRoutes";
import ApplicationRoutes from "./Views/Application/ApplicationRoutes";
import ScanQr from "./Views/Application/ScanQr"
import { Stack } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { EmptyState } from "./Components/ui";

const routes = [
  ...ApplicationRoutes,
  ...SessionRoutes,
  {
    path: "/",
    element: <ScanQr/>,
  },
  {
    path: "403",
    element: (
      <Stack minHeight="100vh" justifyContent="center">
        <EmptyState
          icon={<LockOutlinedIcon />}
          title="Permission denied"
          message="You don't have access to this page."
          actionLabel="Go to home"
          onAction={() => window.location.assign("/")}
        />
      </Stack>
    ),
  },
  {
    path: "*",
    element: (
      <Stack minHeight="100vh" justifyContent="center">
        <EmptyState
          icon={<SearchOffIcon />}
          title="Page not found"
          message="The page you're looking for doesn't exist or has moved."
          actionLabel="Go to home"
          onAction={() => window.location.assign("/")}
        />
      </Stack>
    ),
  },
];

export default routes;
